var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},_vm._l((_vm.itemsText),function(element){return _c('div',{key:element.value,staticClass:"d-flex justify-end align-center mb-1"},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({staticClass:"a-text description",style:({
            color: _vm.$vuetify.theme.themes.light[_vm.color[element.color]] + 'BB',
          })},'span',attrs,false),on),[_vm._v(_vm._s(_vm.item[element.value]))])]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.item[element.value]))])])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }